import React, { useCallback, useMemo } from 'react';

import type { QuickInsertSelectionHandler } from '@atlaskit/editor-common/quick-insert/context';
import { QuickInsertProvider } from '@atlaskit/editor-common/quick-insert/provider';

import { performTypeAheadSelection } from '../../../pm-plugins/commands/insert-type-ahead-item';
import { useTypeAheadContext } from '../useTypeAheadContext';

export const TypeAheadQuickInsertProvider = ({
	children,
}: React.PropsWithChildren): React.JSX.Element => {
	const { editorView, inputMethod, onClose, query, triggerHandler } = useTypeAheadContext();
	const select = useCallback(
		(selectionHandler: QuickInsertSelectionHandler) => {
			onClose();
			queueMicrotask(() => {
				performTypeAheadSelection(editorView)({
					handler: triggerHandler,
					inputMethod,
					query,
					selectionHandler,
				});
			});
		},
		[editorView, inputMethod, onClose, query, triggerHandler],
	);
	const contextValue = useMemo(
		() => ({
			editorView,
			select,
		}),
		[editorView, select],
	);

	return <QuickInsertProvider value={contextValue}>{children}</QuickInsertProvider>;
};
